import { useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

require("../../assets/stylesheets/Main/Slider.css");

function Slider() {
  let items = [];
  useEffect(() => {
    items = document.getElementsByClassName("carousel-item");

    if (items) {
      items[0].classList.add("carousel-item-active");
      items[0].id = "carousel-item-active";
    }

    if (items.length > 1) {
      items[1].classList.add("carousel-next-item");
      items[items.length - 1].classList.add("carousel-prev-item");
    } else {
      document.getElementById("carousel-controllers").remove();
    }

    for(let i = 0; i < items.length; i++){
        items[i].onwheel = moveWithWheel;
      }
  });

  let nextItemToActive = 0;

  function cleanCarouselPath() {
    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove("carousel-prev-item");
      items[i].classList.remove("carousel-next-item");
    }
  }

  function goToNextItem() {
    let activeItem = document.getElementById("carousel-item-active");
    cleanCarouselPath();
    if (nextItemToActive != items.length - 1) {
      activeItem.classList.remove("carousel-item-active");
      activeItem.classList.remove("carousel-next-item");
      activeItem.id = "";
      nextItemToActive++;
      items[nextItemToActive].classList.add("carousel-item-active");
      items[nextItemToActive].id = "carousel-item-active";
      items[nextItemToActive].classList.remove("carousel-next-item");
      items[nextItemToActive - 1].classList.add("carousel-prev-item");
      if (nextItemToActive + 1 == items.length) {
        items[0].classList.add("carousel-next-item");
      } else {
        items[nextItemToActive + 1].classList.add("carousel-next-item");
      }
    } else {
      activeItem.classList.remove("carousel-item-active");
      activeItem.classList.add("carousel-prev-item");
      activeItem.id = "";
      items[0].classList.add("carousel-item-active");
      items[0].id = "carousel-item-active";
      items[1].classList.add("carousel-next-item");

      nextItemToActive = 0;
    }
  }

  function goToPrevItem() {
    let activeItem = document.getElementById("carousel-item-active");
    cleanCarouselPath();
    if (nextItemToActive != 0) {
      activeItem.classList.remove("carousel-item-active");
      activeItem.classList.remove("carousel-prev-item");
      activeItem.id = "";
      nextItemToActive--;
      items[nextItemToActive].classList.add("carousel-item-active");
      items[nextItemToActive].id = "carousel-item-active";
      items[nextItemToActive].classList.remove("carousel-prev-item");
      if (nextItemToActive == 0) {
        items[items.length - 1].classList.add("carousel-prev-item");
      } else {
        items[nextItemToActive - 1].classList.add("carousel-prev-item");
      }
      items[nextItemToActive + 1].classList.add("carousel-next-item");
    } else {
      activeItem.classList.remove("carousel-item-active");
      activeItem.classList.add("carousel-next-item");
      activeItem.id = "";
      items[items.length - 1].classList.add("carousel-item-active");
      items[items.length - 1].id = "carousel-item-active";
      items[items.length - 2].classList.add("carousel-prev-item");
      nextItemToActive = items.length - 1;
    }
  }

  function moveWithWheel(event) {
    event.preventDefault();
  
    if(event.deltaY > 0){
      setTimeout(goToNextItem(),500);
    }else if(event.deltaY < 0){
      setTimeout(goToPrevItem(),500);
    }
  }

  return (
    <div>
      <div className="carousel">
        <h1 className="title-carousel">Nuestro Jurado</h1>
        <div className="carousel-container">
          <div className="carousel-content">
            <div
              className="prev-alternative-area"
              id="prev-alternative-area"
              onClick={goToPrevItem}
            ></div>
            
            <div className="carousel-item">
              <div className="carousel-item-body">
                <img
                  src={require(`../../assets/images/judges/AnaGarcia.jpeg`)}
                  alt=""
                  loading="lazy"
                />
                <div className="carousel-body-item-details">
                  <h1>Lic. Ana Garcia</h1>
                </div>
              </div>
              <div className="carousel-item-details">
                  <p>Licenciada en Marketing y Diseño Gráfico.</p>
                </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-item-body">
                <img
                  src={require(`../../assets/images/judges/AntonioRocha2.jpeg`)}
                  alt=""
                  loading="lazy"
                />
                <div className="carousel-body-item-details">
                  <h1>Ing. Antonio Rocha</h1>
                </div>
              </div>
              <div className="carousel-item-details">
                  <p>Director de Asuntos estudiantiles - UTH Tegucigalpa.</p>
                </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-item-body">
                <img
                  src={require(`../../assets/images/judges/NubiaSanchez.jpeg`)}
                  alt=""
                  loading="lazy"
                />
                <div className="carousel-body-item-details">
                  <h1>Ing. Nubia Sánchez</h1>
                </div>
              </div>
              <div className="carousel-item-details">
                  <p>Coordinadora de la facultad de Negocios y maestría - UTH.</p>
                </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-item-body">
                <img
                  src={require(`../../assets/images/judges/SulemaSosa.jpeg`)}
                  alt=""
                  loading="lazy"
                />
                <div className="carousel-body-item-details">
                  <h1>Lic. Sulema Sosa</h1>
                </div>
              </div>
              <div className="carousel-item-details">
                  <p>Directora de Facultad de Negocios.</p>
                </div>
            </div>
            <div
              className="next-alternative-area"
              id="next-alternative-area"
              onClick={goToNextItem}
            ></div>
          </div>
        </div>
        <div className="carousel-controllers" id="carousel-controllers">
          <div id="prev-carousel-item" onClick={goToPrevItem}>
            <FaArrowLeft />
          </div>
          <div id="next-carousel-item" onClick={goToNextItem}>
            <FaArrowRight />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Slider;
